import useUploadContext from 'hooks/useUploadContext';
import Button from '@mui/material/Button';
import Box from "@mui/material/Box";

import "./index.scss";

const StartMenu = () => {
    const { setLeftTab, handleResetProject } = useUploadContext();

    const handleDraftsClick = () => {
        setLeftTab('drafts');
    };

    const handleNewProjectClick = () => {
        handleResetProject();
        setLeftTab('layers');
    };

    return (
        <Box className="start-menu-component">
            <Button onClick={handleDraftsClick}>Drafts</Button>
            <Button onClick={handleNewProjectClick}>New project</Button>
        </Box>
    );
};

export default StartMenu;
